/* eslint-disable import/prefer-default-export */
import merge from '../../utilities/merge'
import { actionTypeSuffixes } from '../actionTypes/generators'
import { actionCreators } from '../actionCreators'

// Generate (an object containing) workflow actionCreators
// - an object containing the required actionCreators
// This is the structured object that can be used to pass the required actionTypes to a process workflow saga
// i.e. the begin, success, and fail actionCreators that processSaga will call at the appropriate time
// see actionCreatorForActionType for the details about the actionCreator functions
export const workflowActionCreatorsForName = name => ({ [name]: merge(Object.entries(actionTypeSuffixes).map(([key, suffix]) => ({ [key]: actionCreators[`${name}${suffix}`] }))) })
//
// E.g. (assuming that 'nounVerb' is a workflow actionType and all of the 'nounVerb' related actionCreators are exported in actionCreators)
// workflowActionCreatorsForName('nounVerb')
// --> { nounVerb: { begin: [Function: actionCreator], success: [Function: actionCreator], fail: [Function: actionCreator] } }
//



// WEBPACK FOOTER //
// ./src/redux/actionWorkflows/generators.js